import type { IApiSlideResponse } from '@/services';
import type { ISlideData } from '@/entities';

export const mapApiSlide = (data: Readonly<IApiSlideResponse>): ISlideData => {
  return {
    id: data.id,
    header: data.header,
    description: data.description,
    imageUrl: data.imageUrl,
    order: data.order,
    primaryActionUrl: data.primaryActionUrl
  };
};
